import { FC } from 'react';
import styled from 'styled-components';
import { useRef } from 'react';
import useOnClickOutside from 'hooks/useOutsideClick';
import { ACCOUNT_MANAGEMENT_MODAL_COPY } from 'constants/accounts';

const ActionsContainer = styled.ul`
  width: 189px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 0;
  border-radius: 10px;
  margin: 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #222222;
`;

const ActionItem = styled.li`
  line-height: 36px;
  list-style: none;
  color: #fff;
`;

interface MobileAccountActionsProps {
  onManageAccount: () => void;
  onCreateDomain: () => void;
  onClose: () => void;
}

const MobileAccountActions: FC<MobileAccountActionsProps> = ({
  onManageAccount,
  onCreateDomain,
  onClose,
}) => {
  const ref = useRef();
  useOnClickOutside(ref, onClose);

  return (
    <ActionsContainer ref={ref}>
      <ActionItem onClick={onManageAccount}>
        {ACCOUNT_MANAGEMENT_MODAL_COPY.manageAccountEntryLabel}
      </ActionItem>
      <ActionItem onClick={onCreateDomain}>Create domain</ActionItem>
    </ActionsContainer>
  );
};

export default MobileAccountActions;
